export const DEV_BASE_URL = 'http://127.0.0.1:8000';
export const STAGE_BASE_URL = 'http://192.168.10.30:8016';
export const PROD_BASE_URL = "https://utility-api.arth.bz"

// Comment or uncomment to switch between DEV, STAGE, PROD environments
export const ACTIVE_URL = PROD_BASE_URL;

export const ALLOWED_EMAIL_DOMAINS = ['arthimpact.in'];
